import { API } from 'configs';
import { usePaging, useAddEdit } from 'utils/AxiosHooks';

const usePointHistories = () => usePaging(API.ADMIN.POINT_HISTORY.LIST, false);

const useAddPoint = (id) => useAddEdit(API.ADMIN.POINT_HISTORY.ADD, 'add');

export { usePointHistories, useAddPoint };
